import { ASSET, renewalPath } from './paths'

export type IndustryItem = {
  key: string
  name: string
  path: string
}

export const INDUSTRIES: IndustryItem[] = [
  { key: 'icecream', name: '아이스크림 할인점', path: renewalPath('/industries/ice-cream') },
  { key: 'laundry', name: '셀프빨래방', path: renewalPath('/industries/laundromat') },
  { key: 'study', name: '스터디카페', path: renewalPath('/industries/study-cafe') },
  { key: 'cafe', name: '무인카페', path: renewalPath('/industries/unmanned-cafe') },
  { key: 'store', name: '무인편의점', path: renewalPath('/industries/unmanned-store') },
  { key: 'stationery', name: '무인문구점', path: renewalPath('/industries/stationery') },
  { key: 'photo', name: '무인사진관', path: renewalPath('/industries/photo-booth') },
  { key: 'mealkit', name: '자판기·밀키트', path: renewalPath('/industries/vending-mealkit') },
  { key: 'print', name: '무인 프린트', path: renewalPath('/industries/print-shop') },
  { key: 'storage', name: '무인창고', path: renewalPath('/industries/storage') },
  { key: 'etc', name: '그 외 업종', path: renewalPath('/industries/others') },
]

export type ServiceItem = {
  key: string
  name: string
  path: string
  icon: string
}

export const SERVICES: ServiceItem[] = [
  {
    key: 'fridge',
    name: '무인냉장고 창업',
    path: renewalPath('/snackberry'),
    icon: 'M5 2h14v20H5zM5 6h14M8 9h8v10H8zM8 12.5h8M8 16h8M17.5 11v4M7 22v-1M17 22v-1',
  },
  {
    key: 'addon',
    name: '간판·어닝 청소',
    path: renewalPath('/add-on/sign'),
    icon: 'M3 4h18v9H3zM7 13v7M17 13v7M7 8.5h10',
  },
  {
    key: 'aircon',
    name: '에어컨 분해 청소',
    path: renewalPath('/add-on/aircon'),
    icon: 'M3 5h18v8H3zM6 9.5h12M7 16.5c0 1.5-1 2-1 3.5M12 16.5v3.5M17 16.5c0 1.5 1 2 1 3.5',
  },
  {
    key: 'window',
    name: '유리창 전문 청소',
    path: renewalPath('/add-on/window'),
    icon: 'M4 3h16v18H4zM12 3v18M4 12h16M7 6l2 2',
  },
  {
    key: 'dryer',
    name: '건조기 분해 청소',
    path: renewalPath('/add-on/dryer'),
    icon: 'M5 3h14v18H5zM5 7h14M12 10a4 4 0 1 0 0 8a4 4 0 1 0 0-8M8 5h.01',
  },
  {
    key: 'supply',
    name: '소모품 패키지 제작',
    path: renewalPath('/supply'),
    icon: 'M21 8l-9-5-9 5v8l9 5 9-5zM3 8l9 5 9-5M12 13v8M7.5 5.5l9 5',
  },
  {
    key: 'cs',
    name: 'CS 서비스',
    path: renewalPath('/cs'),
    icon: 'M4 14v-2a8 8 0 0 1 16 0v2M4 14h3v6H4zM17 14h3v6h-3zM20 20a3 3 0 0 1-3 2h-3',
  },
]

export const industryIcon = (key: string) => `${ASSET}/icons3d/${key}.png`

export type RenewalCurrent =
  | 'home'
  | 'industry'
  | 'cases'
  | 'pricing'
  | 'business'
  | 'shop'
  | 'faq'
  | 'fridge'
  | 'addon'
  | 'aircon'
  | 'window'
  | 'dryer'
  | 'supply'
  | 'cs'
  | 'story'
  | 'press'
  | 'apply'
  | 'mypage'
  | 'myservice'
  | 'payment'
